import { useEffect, useMemo, useState } from 'react';

import { fetchReviewStats } from './api';
import { reviewStatsMapFromResponse } from './listingReviews';

const useReviewStats = listingIds => {
  const idsKey = (listingIds || []).filter(Boolean).join(',');
  const ids = useMemo(() => idsKey.split(',').filter(Boolean), [idsKey]);
  const [map, setMap] = useState({});

  useEffect(() => {
    if (ids.length === 0) {
      setMap({});
      return undefined;
    }
    let cancelled = false;
    const load = () => {
      Promise.resolve()
        .then(() => fetchReviewStats(ids))
        .then(payload => {
          if (!cancelled) {
            setMap(reviewStatsMapFromResponse(payload));
          }
        })
        .catch(() => {});
    };
    load();
    return () => {
      cancelled = true;
    };
  }, [ids]);

  return map;
};

export default useReviewStats;
